// Frontend feedback contract + the single seam where auto-captured context is
// assembled. This mirrors the backend contract in
// firebase/functions/src/feedback/types.ts (the two can't share a module — the
// app and the functions have separate builds). Keep them in sync; the sink
// only reads the context fields it knows and sanitises each, so an extra or
// renamed field is silently ignored rather than trusted.
//
// Extension point: every further context field (active filters,
// visible columns, chart metrics; a screenshot reference) is added HERE, on
// FeedbackContext, and populated in buildFeedbackContext(). The widget, the
// request body, and the backend then carry it unchanged — no other edits.

import { formatClientName } from "@dashai/lib/utils";

/** Auto-captured context sent nested under the request body's `context`. */
export interface FeedbackContext {
  page: string | null;
  id_client: string | null;
  workspace_label: string | null;
  market: string | null;
}

export interface FeedbackContextInput {
  /** Current route path, e.g. "/market_overview". */
  page: string | null;
  /** Active workspace id from Redux auth, e.g. "ko_global". */
  id_client: string | null;
  /** Selected market/country from Redux filters, e.g. "US". */
  market: string | null;
}

/**
 * Assemble the context payload. The workspace display name is derived here from
 * the id (so the team's notification reads "KO Global", not "ko_global"); the
 * backend re-verifies the id and drops the label if the user can't access it.
 */
export function buildFeedbackContext({
  page,
  id_client,
  market,
}: FeedbackContextInput): FeedbackContext {
  return {
    page: page ?? null,
    id_client: id_client ?? null,
    workspace_label: id_client ? formatClientName(id_client) : null,
    market: market ?? null,
  };
}
